<!-- PDF Upload Panel - Simplified for Hero Ensure Policy PDF Only -->
<div *ngIf="hasUploadPermission" class="card shadow-sm border-0 mb-4">
  <div class="card-header bg-primary text-white">
    <h6 class="mb-0 d-flex align-items-center">
      <i class="fa fa-file-pdf-o mr-2"></i>
      Smart Form Filler - Upload PDF
      <small class="ml-auto badge badge-light text-primary">
        Auto-populate
      </small>
    </h6>
  </div>
  
  <div class="card-body">
    <!-- Information Message -->
    <div class="alert alert-info mb-2">
      <i class="fa fa-info-circle mr-1"></i>
      <small><strong>Note:</strong> Upload <strong>Vehicle Insurance policy PDF</strong> to auto-populate form fields.</small>
    </div>

    <!-- Upload Area -->
    <div *ngIf="!selectedFile" class="compact-upload-inline">
      <label class="d-flex align-items-center mb-0">
        <i class="fa fa-file-pdf-o mr-2 text-primary"></i>
        <span class="mr-2 small">Upload Vehicle Insurance policy PDF:</span>
        <button type="button" class="btn btn-outline-primary btn-sm" 
                onclick="document.getElementById('pdfFileInput').click()">
          <i class="fa fa-folder-open mr-1"></i>
          Choose File
        </button>
        <input type="file" 
               id="pdfFileInput" 
               accept=".pdf" 
               style="display: none" 
               (change)="onFileSelected($event)">
      </label>
      <small class="text-muted d-block mt-1">
        PDF files only | Max size: 10MB
      </small>
    </div>

    <!-- Processing State -->
    <div *ngIf="isProcessing" class="text-center py-4">
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="sr-only">Processing...</span>
      </div>
      <h6>Extracting data from PDF...</h6>
      <p class="text-muted small">
        Please wait while we extract information from your Vehicle Insurance policy document.
      </p>
      <div class="progress mx-auto" style="width: 300px;">
        <div class="progress-bar progress-bar-striped progress-bar-animated" 
             [style.width.%]="uploadProgress">
          {{uploadProgress}}%
        </div>
      </div>
    </div>

    <!-- File Info & Success Message -->
    <div *ngIf="selectedFile && !isProcessing && extractionResult?.success" class="row">
      <div class="col-12">
        <div class="alert alert-success d-flex align-items-center">
          <i class="fa fa-check-circle fa-2x mr-3"></i>
          <div class="flex-grow-1">
            <strong>PDF Uploaded Successfully!</strong>
            <br>
            <small>File: {{selectedFile.name}} ({{(selectedFile.size / (1024*1024)).toFixed(2)}} MB)</small>
            <br>
            <small class="text-success mt-2 d-block">
              <i class="fa fa-magic mr-1"></i>
              Form fields have been automatically populated.
            </small>
          </div>
          <button type="button" 
                  class="btn btn-sm btn-outline-danger" 
                  (click)="clearFile()"
                  title="Remove file">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="alert alert-info mt-3">
          <i class="fa fa-info-circle mr-2"></i>
          <strong>FYI:</strong> Please review the filled-in fields highlighted in <strong style="background-color: #fff3cd; padding: 2px 4px; border-radius: 3px;">yellow</strong> to ensure accuracy.
        </div>
      </div>
    </div>

    <!-- Error Message -->
    <div *ngIf="selectedFile && !isProcessing && extractionResult && !extractionResult.success" class="row">
      <div class="col-12">
        <div class="alert alert-warning">
          <i class="fa fa-exclamation-triangle mr-2"></i>
          <strong>Extraction Issues:</strong>
          <ul class="mb-0 mt-2">
            <li *ngFor="let error of extractionResult.errors">{{error}}</li>
            <li *ngFor="let warning of extractionResult.warnings" class="text-muted">{{warning}}</li>
          </ul>
          <button type="button" 
                  class="btn btn-sm btn-outline-danger mt-2" 
                  (click)="clearFile()"
                  title="Remove file">
            <i class="fa fa-times mr-1"></i>
            Clear and Try Again
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
